module.exports = __webpack_public_path__ + "static/img/008城市名片8.4df82bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/008城市名片8.jpg
// module id = VcEW
// module chunks = 0